import { SxProps } from "@mui/system";
import { ThemeV2 } from "../../../util/types";
import { hostThemes } from "../../../theme/hostThemes";

const { header, shell } = hostThemes.chat;

export const headerContainer = (
  theme: ThemeV2,
  timerImageOPen: boolean,
): SxProps => ({
  width: "inherit",
  padding: `${header.verticalInset}px ${header.horizontalInset}px`,
  borderRadius: {
    xs: 0,
    sm: `${shell.cornerRadius}px ${shell.cornerRadius}px 0 0`,
  },
  display: "flex",
  alignItems: "center",
  flexDirection: "row",
  justifyContent: "space-between",
  backgroundColor: theme.tokens.color.action.primary,
  boxShadow: theme.tokens.elevation["1"],
  opacity: timerImageOPen ? "0.1" : "1",
  position: "sticky",
  top: 0,
  zIndex: 1,
});

export const headerInfo = (theme: ThemeV2): SxProps => ({
  fontSize: theme.tokens.typography.size.xs,
  color: theme.tokens.color.action.primaryText,
  fontWeight: theme.tokens.typography.weight.regular,
});

export const headerName = (theme: ThemeV2): SxProps => ({
  fontSize: theme.tokens.typography.size.lg,
  color: theme.tokens.color.action.primaryText,
  fontWeight: theme.tokens.typography.weight.bold,
});
